<template>
  <div>
    <el-menu
      mode="horizontal"
      background-color="#141414"
      text-color="#fff"
      active-text-color="#00d2d3"
      v-if="pMenuList.length"
      :router="true"
      :default-active="defaultActive"
      @select="selectHandler"
    >
      <!-- 这里先将一级菜单生成，防止调用递归子菜单时多一个根div，影响样式 -->
      <template v-for="(value,index) in this.pMenuList">
        <el-submenu
          :index="value.Url=='#'?value.Url+index:value.Url"
          v-if="hasChild(value.ID)"
          :key="value.ID"
        >
          <template slot="title">
            <i :class="value.Icon"></i>
            {{value.Name}}
          </template>
          <MyMenu :pID="value.ID"></MyMenu>
        </el-submenu>
        <el-menu-item :index="value.Url=='#'?value.Url+index:value.Url" v-else :key="value.ID">
          <i :class="value.Icon"></i>
          {{value.Name}}
        </el-menu-item>
        
      </template>
    </el-menu>
  </div>
</template>

<script>
import MyMenu from "./Menu"; //引入子菜单组件

export default {
  name: "HorizontalMenu",
  props: {
    rootID: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    //子菜单递归组件
    MyMenu
  },
  data() {
    return {
      //存储所有菜单的项
      menuList: this.$store.state.menuData,
      //存储一级菜单的项
      pMenuList: [],
      defaultActive: ""
    };
  },
  created() {
    this.menuList = this.$store.state.menuData;
    let match = window.sessionStorage.getItem("curMenu");
    this.setLeftMenuInfo(match);
    this.getMenu();
  },
  methods: {
    //获取菜单数据
    getMenu() {
      var that = this;
      that.pMenuList = that.menuList.filter(function(m) {
        return m.ParentID == that.rootID; //一级菜单父id为"0"
      });
    },
    //判断是否还有子菜单
    hasChild(id) {

      let that = this;
      let curMenu=that.menuList.filter(function(m) {
        return m.ID == id;
      });
      let tempMenuList = that.menuList.filter(function(m) {
        return m.ParentID == id;
      });
      if (tempMenuList.length>0&&curMenu[0].IsDropDown!="0") {
        return true;
      }
      return false;
    },
    //切换菜单时判断IsDropDown是否为1，1：代表子菜单下拉表示，0：代表子菜单用左侧菜单来展示
    selectHandler(index, indexPath) {
      this.setLeftMenuInfo(index);
      this.$store.commit("setCurMenu", index);
      this.$store.commit("saveCurLeftMenu",index);
    },
    setLeftMenuInfo(path) {
      let menuObj = this.menuList.filter(item => {
        return item.Url == path&&item.IsDropDown=="0";
      });
      if (menuObj.length > 0 && menuObj[0].IsDropDown != "1") {
        this.$store.commit("saveLeftMenuVisible", true);
        this.$store.commit("saveLeftMenuPID", menuObj[0].ID);
        
      } else {
        this.$store.commit("saveLeftMenuVisible", false);
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      //页面刷新后重新将当前选中的菜单置为选中项,这里设置curMenu的值依赖面包屑组件
      let match = window.sessionStorage.getItem("curMenu");
      this.defaultActive = match;
    });
  },
  watch: {
    "$store.state.curMenu": function(newValue, oldValue) {
      this.defaultActive = newValue;
    }
  },
  computed:{
    
  }
};
</script>

<style lang="less" scoped>
.el-submenu.is-active i {
  color: inherit;
}
.el-menu.el-menu--horizontal{
  border-bottom: 0px;
}
/deep/.el-submenu .el-submenu__title {
  font-size: 14px;
}
/deep/.el-submenu .el-submenu__title i{
  color:#fff;
 
}
/* 未选中时的颜色继承title颜色，分为有子菜单和没有子菜单时 */

.el-submenu__title i {
  color: inherit;
}

.el-menu-item {
  font-size: 14px;
}
/deep/ .el-submenu .el-submenu__title{
  font-size:14px;
  height: 50px;
}
/deep/.el-menu--horizontal>.el-submenu .el-submenu__title{
height: 50px !important;
line-height: 50px;
}
.el-menu--horizontal>.el-menu-item{
height: 50px;
line-height: 50px;
}
/deep/.el-menu-item i {
  color: inherit;
}

.el-submenu.is-active i {
  color: inherit;
}
</style>